import { Status } from "./enums";

export class Constants {
  public static appDefaultLocale = "en-US";
  public static defaultTimeValue = "00:00:00";
  public static commandInvokeFunctionName = "ap-fun-dmp-edl-driver-sg";
  public static HttpResponseErrorCode = [0, 401, 404, 500];
  public static Comma = ",";
}

export class CommonFieldName {
  public static apexId = "apexId";
  public static country = "country";
  public static subRegionName = "subRegionName";
  public static subRegion_ids = "subRegion_ids";
  public static terminalName = "terminalName";
  public static terminalId = "terminalId";
  public static terminal_Ids = "terminal_Ids";
  public static terminal_ids = "terminal_ids";
  public static terminal = "terminal";

  public static kpiId = "kpiid";

  public static lastModified_By = "lastModified_By";
  public static lastModified_On = "lastModified_On";

  public static sheetName = "sheetName";
  public static rowNum = "rowNum";
  public static errorMessage = "errorMessage";
  public static translationId = "translation_Id";
  public static attachment = "attachment";
  public static businessType = "businessType";
  public static businessTypes = "businessTypes";
}

export class CommonFieldLabel {
  public static BUSINESS_TYPE = "ml_144070";
  public static ATTACHMENT = "ml_144011";
  public static SHEET_NAME = "ml_151080";
  public static LINE_NUMBER = "ml_143953";
  public static IMPORT_FAILED_MESSAGE = "ml_143954";
  public static LAST_CHANGED_BY = "ml_143918";
  public static LAST_CHANGED_ON = "ml_143919";
}

export class ComponentConstants {
  public static dataGridExpandableColumnName = "expand";
}

export class PageRoutePath {
  public static KPI_WEIGHT = "kpi-weight";
  public static USER_PROFILE = "user-profile";
  public static ORG_UNIT = "org-unit";
  public static DRIVER_DATA = "driver-data";
  public static KPI_IT_TOOLS_USAGE = "kpi-it-tools-usage";
  public static KPI_SAFETY = "kpi-safety";
  public static KPI_DRIVING_BEHAVIOR = "kpi-driving-behavior";
  public static KPI_ECONOMY = "kpi-economy";
  public static KPI_OTHERS = "kpi-others";
  public static COACHING = "coaching";
  public static ACHIEVEMENT = "achievement";
  public static AWARD = "award";
  public static REPORT_LINK = "report-link";
  public static TEAM_MESSAGE = "team-message";
  public static SET_APEX_ID = "set-apex-id/:apexid";
  public static SUPERVISOR_CONTROL_PANEL = "owner-only/supervisor-control-panel";
  public static HOME = "home";
  public static EXTERNAL_REPORT = "external_report";
  public static SUPERVISOR_DASHBOARD = "supervisor-dashboard";
  public static EMBED_QLIK_REPORT_TEST = "embed-qlik-report-test";
  public static EMBED_QLIK_REPORT_TEST_ANDY = "embed-qlik-report-test-andy";
  public static EMBED_QLIK_REPORT_TEST_DEREK = "embed-qlik-report-test-derek";
  public static COUNTRY_LEVEL_OVERVIEW = "country-level-overview";
  public static SUBREGION_LEVEL_REPORT_KPI = "subregion-level-report-kpi";
  public static SUBREGION_LEVEL_REPORT_ECONOMY_KPI = "subregion-level-report-economy-kpi";
  public static TERMINAL_LEVEL_REPORT_KPI = "terminal-level-report-kpi";
  public static TERMINAL_LEVEL_REPORT_ECONOMY_KPI = "terminal-level-report-economy-kpi";
  public static KPI_SUMMARY_REPORT_KPI = "kpi-summary-report-kpi";
  public static KPI_SUMMARY_REPORT_ECONOMY_KPI = "kpi-summary-report-economy-kpi";
  public static DRIVER_PORTRAIT = "driver-portrait";
  public static DATA_COMPLETENESS = "data-completeness";
  public static ACHIEVEMENT_REPORT = "achievement-report";
  public static LEARNEX_REPORT = "learnex-report";
  public static NAVIGATION = "navigation";
  public static BATCH_IMPORT_EXCEL = "batch-import-excel";
  public static POWER_APP = "power-app";
}

export class WebApiRoute {
  public static DRIVER_TERMINAL = "driver/terminals";
  public static ORG_SUBREGIONS = "org/subregions";
  public static DRIVER_DATA = "driver";
  public static ORG_UNIT = "org";
  public static ORG_UNIT_TERMINALS = "org/terminals";
  public static ORG_UNIT_TERMINALS_WITHOUT_SUBREGION = "org/terminals/without/subregions";
  public static KPI_IT_TOOL_USAGE = "kpi/ittoolusage";
  public static KPI_SAFETY = "kpi/safty";
  public static KPI_DRIVING_BEHAVIOR = "kpi/drivingbehavior";
  public static KPI_ECONOMY = "kpi/economy";
  public static KPI_OTHERS = "kpi/others";
  public static KPI_CONFIGURATION = "kpi/configuration";
  public static KPI = "kpi";

  public static DRIVER = "driver";
  public static COACHING = "coaching";
  public static USER_PROFILE = "userprofile";
  public static USER_PROFILE_ME = "userprofile/me";
  public static USER_PROFILE_SPECIFIED = "userprofile?apexid=";
  public static USER_PROFILE_ROLE = "userprofile/role";
  public static USERPROFILE_VALIDATE = "userprofile/validate";
  public static ACHIEVEMENT = "achievement/achieve";
  public static AWARD = "award";
  public static AWARD_IMPORT = "award/awards";
  public static REPORT_LINK = "reportlink";
  public static TEAM_MESSAGE = "teammessage";
  public static TEAM_MESSAGE_READ = "teammessage/drivers";
  public static COMMAND_INVOKE = "command/invoke";
  public static DATA_IMPORT_VALIDATE = "command/validate";
}

export class NgxsActionName {
  public static UPLOAD_ATTACHMENT = "UploadAttachment";

  public static GET_DRIVER_DATA = "GetDriverData";
  public static UPDATE_DRIVER_DATA = "UpdateDriverData";

  public static GET_TERMINALS_WITHOUT_SUBREGION = "GetTerminalsWithoutSubregion";
  public static GET_ORG_UNIT = "GetOrgUnit";
  public static UPDATE_ORG_UNIT = "UpdateOrgUnit";
  public static DELETE_ORG_UNIT = "DeleteOrgUnit";
  public static GET_KPI_IT_TOOL_USAGE = "GetKpiITToolUsage";
  public static UPDATE_KPI_IT_TOOL_USAGE = "UpdateKpiITToolUsage";
  public static DELETE_KPI_IT_TOOL_USAGE = "DeleteKpiITToolUsage";
  public static IMPORT_KPI_IT_TOOL_USAGE_DATA = "ImportKpiITToolUsageData";
  public static IMPORT_EVCR_COMPLIANCE_DATA = "ImportEVCRComplianceData";
  public static IMPORT_APT_COMPLIANCE_DATA = "ImportAPTComplianceData";
  public static IMPORT_SAFTY_MEETING_COMPLIANCE_DATA = "ImportSaftyMettingComplianceData";

  public static GET_KPI_SAFETY = "GetKpiSafety";
  public static UPDATE_KPI_SAFETY = "UpdateKpiSafety";

  public static GET_KPI_DRIVING_BEHAVIOR = "GetKpiDrivingBehavior";
  public static UPDATE_KPI_DRIVING_BEHAVIOR = "UpdateKpiDrivingBehavior";
  public static DELETE_KPI_DRIVING_BEHAVIOR = "DeleteKpiDrivingBehavior";
  public static IMPORT_KPI_DRIVING_BEHAVIOR_DATA = "ImportKpiDrivingBehaviorData";

  public static GET_KPI_ECONOMY = "GetKpiEconomy";
  public static UPDATE_KPI_ECONOMY = "UpdateKpiEconomy";
  public static DELETE_KPI_ECONOMY = "DeleteKpiEconomy";
  public static IMPORT_KPI_ECONOMY_DATA = "ImportKpiEconomyData";

  public static GET_USER_PROFILE = "GetUserProfile";
  public static GET_USER_PROFILE_ROLE = "GetUserProfileRole";
  public static UPDATE_USER_PROFILE = "UpdateUserProfile";
  public static DELETE_USER_PROFILE = "DeleteUserProfile";

  public static GET_KPI_OTHERS = "GetKpiOthers";
  public static GET_KPI_OTHERS_ATTACHMENT = "GetKpiOthersAttachment";
  public static UPDATE_KPI_OTHERS = "UpdateKpiOthers";
  public static DELETE_KPI_OTHERS = "DeleteKpiOthers";

  public static GET_COACHING = "GetCoaching";
  public static GET_COACHING_ATTACHMENT = "GetCoachingAttachment";
  public static UPDATE_COACHING = "UpdateCoaching";
  public static UPLOAD_COACHING_ATTACHMENT = "UploadCoachingAttachment";

  public static GET_DRIVER_RELATED_TERMINAL_LIST = "GetDriverRelatedTerminalList";
  public static GET_SUB_REGION_RELATED_TERMINAL_LIST = "GetSubRegionRelatedTerminalList";
  public static GET_ORG_TERMINAL_LIST = "GetOrgTerminalList";
  public static GET_SUB_REGIONS = "GetSubRegions";
  public static GET_KPI_ALL = "GetKpiAll";
  public static SEARCH_DRIVERS_WITH_MY_PROFILE = "SearchDriversWithMyProfile";

  public static GET_ACHIEVEMENT = "GetAchievement";
  public static IMPORT_ACHIEVEMENT_DATA = "ImportAchievementData";
  public static UPDATE_ACHIEVEMENT = "UpdateAchievement";

  public static GET_AWARD = "GetAward";
  public static IMPORT_AWARD_DATA = "ImportAwardData";
  public static UPDATE_AWARD = "UpdateAward";
  public static DELETE_AWARD = "DeleteAward";

  public static GET_REPORT_LINK = "GetReportLink";
  public static UPDATE_REPORT_LINK = "UpdateReportLink";
  public static DELETE_REPORT_LINK = "DeleteReportLink";

  public static GET_EXTERNAL_REPORT = "GetExternalReport";

  public static GET_TEAM_MESSAGE = "GetTeamMessage";
  public static UPDATE_TEAM_MESSAGE = "UpdateTeamMessage";
  public static GET_DRIVER_BY_TERMINAL = "GetDriverByTerminal";
  public static GET_TEAM_MESSAGE_READ = "GetTeamMessageRead";
  public static GET_TEAM_MESSAGE_READ_FOR_EXPORT = "GetTeamMessageReadForExport";

  public static GET_KPI_CONFIGURATION = "GetKpiConfiguration";
  public static UPDATE_KPI_CONFIGURATION = "UpdateKpiConfiguration";

  public static VALIDATE_USER_PROFILE = "ValidateUserProfile";
  public static COMMAND_INVOKE = "CommandInvoke";
  public static GET_USER_PROFILE_ME = "GetUserProfileMe";

  public static DATA_IMPORT_VALIDATE = "DataImportValidate";
}

export class NgxsFormPath {
  public static DRIVER_DATA_SEARCH_FORM = "appDataState.driverData.search.searchForm";
  public static DRIVER_DATA_EDIT_FORM = "appDataState.driverData.edit.editForm";
  public static ORG_UNIT_SEARCH_FORM = "appDataState.orgUnit.search.searchForm";
  public static ORG_UNIT_EDIT_FORM = "appDataState.orgUnit.edit.editForm";
  public static USER_PROFILE_SEARCH_FORM = "appDataState.userProfile.search.searchForm";
  public static USER_PROFILE_EDIT_FORM = "appDataState.userProfile.edit.editForm";
  public static KPI_IT_TOOL_USAGE_SEARCH_FORM = "appDataState.itToolUsage.search.searchForm";
  public static KPI_IT_TOOL_USAGE_EDIT_FORM = "appDataState.itToolUsage.edit.editForm";
  public static KPI_SAFETY_USAGE_SEARCH_FORM = "appDataState.safety.search.searchForm";
  public static KPI_SAFETY_EDIT_FORM = "appDataState.safety.edit.editForm";
  public static KPI_DRIVING_BEHAVIOR_SEARCH_FORM = "appDataState.drivingBehavior.search.searchForm";
  public static KPI_DRIVING_BEHAVIOR_EDIT_FORM = "appDataState.drivingBehavior.edit.editForm";
  public static KPI_ECONOMY_SEARCH_FORM = "appDataState.kpiEconomy.search.searchForm";
  public static KPI_ECONOMY_EDIT_FORM = "appDataState.kpiEconomy.edit.editForm";
  public static KPI_OTHERS_SEARCH_FORM = "appDataState.kpiOthers.search.searchForm";
  public static KPI_OTHERS_EDIT_FORM = "appDataState.kpiOthers.edit.editForm";
  public static COACHING_SEARCH_FORM = "appDataState.coaching.search.searchForm";
  public static COACHING_EDIT_FORM = "appDataState.coaching.edit.editForm";
  public static ACHIEVEMENT_SEARCH_FORM = "appDataState.achievement.search.searchForm";
  public static ACHIEVEMENT_EDIT_FORM = "appDataState.achievement.edit.editForm";
  public static AWARD_SEARCH_FORM = "appDataState.award.search.searchForm";
  public static AWARD_EDIT_FORM = "appDataState.award.edit.editForm";
  public static REPORT_LINK_SEARCH_FORM = "appDataState.reportLink.search.searchForm";
  public static REPORT_LINK_EDIT_FORM = "appDataState.reportLink.edit.editForm";
  public static EXTERNAL_REPORT_SEARCH_FORM = "appDataState.externalReport.search.searchForm";
  public static TEAM_MESSAGE_SEARCH_FORM = "appDataState.teamMessage.search.searchForm";
  public static TEAM_MESSAGE_EDIT_FORM = "appDataState.teamMessage.edit.editForm";
  public static TEAM_MESSAGE_READ_SEARCH_FORM = "appDataState.teamMessage.teamMessageReadSearch.searchForm";
  public static KPI_CONFIGURATION_SEARCH_FORM = "appDataState.kpiConfiguration.search.searchForm";
  public static KPI_CONFIGURATION_EDIT_FORM = "appDataState.kpiConfiguration.edit.editForm";
  public static SUPERVISOR_CONTROL_PANEL_EDIT_FORM = "appDataState.supervisorControlPanel.edit.editForm";
}

export const DatepickerYearMonthFormat = {
  parse: {
    dateInput: "MM/YYYY",
  },
  display: {
    dateInput: "MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

export const DatepickerNormalFormat = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "DD MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "DD MMMM YYYY",
  },
};

export class CsvImportColumnName {
  public static YEAR = "Year";
  public static MONTH = "Month";
  public static Date = "Date";
  public static Time = "Time";
  public static KPI_ID = "KPI ID";
  public static SHEET_NAME = "sheetname";
}

export class SelectItems {
  public static complianceSelectItems = [
    { value: true, label: "ml_143931" },
    { value: false, label: "ml_143932" },
  ];
  public static statusSelectItems = [
    { value: Status.ACTIVE, label: "ml_144080" },
    { value: Status.INACTIVE, label: "ml_144081" },
  ];
}

export class ExcelSheetName {
  public static DRIVER_OBSERVATION = "driver observation";
  public static EVCR_COMPLIANCE = "evcr compliance";
  public static APT_COMPLIANCE = "apt compliance";
  public static SAFETY_MEETING_COMPLIANCE = "safety meeting compliance";
  public static AWARD = "award";
}
